import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UploadState {
  allMasterDataOptions: any
}

// --- Safely parse from localStorage ---
let parsedData: any = null
const localStorageData = localStorage.getItem('allMasterDataOptions')

if (localStorageData) {
  try {
    parsedData = JSON.parse(localStorageData)
  } catch (e) {
    console.warn('Invalid JSON found in localStorage. Clearing key.', e)
    localStorage.removeItem('allMasterDataOptions')
  }
}

const initialState: UploadState = {
  allMasterDataOptions: parsedData,
}

const MasterDataSlice = createSlice({
  name: 'allMasterDataOptions',
  initialState,
  reducers: {
    MasterDataStore(state, action: PayloadAction<any>) {
      if (action.payload !== undefined && action.payload !== null) {
        state.allMasterDataOptions = action.payload
        localStorage.setItem(
          'allMasterDataOptions',
          JSON.stringify(action.payload)
        )
      } else {
        // if payload is undefined or null, clear storage
        state.allMasterDataOptions = null
        localStorage.removeItem('allMasterDataOptions')
      }
    },
  },
})

export const { MasterDataStore } = MasterDataSlice.actions
export default MasterDataSlice.reducer



// import {createSlice, PayloadAction} from '@reduxjs/toolkit'

// interface UploadState {
//   allMasterDataOptions: any
// }

// let localStorageData = localStorage.getItem('allMasterDataOptions')
// const initialState: UploadState = {
//   allMasterDataOptions: localStorageData ? JSON.parse(localStorageData) : null,
// }

// const MasterDataSlice = createSlice({
//   name: 'allMasterDataOptions',
//   initialState,
//   reducers: {
//     MasterDataStore(state, action: PayloadAction<any>) {
//       state.allMasterDataOptions = action.payload
//       localStorage.setItem('allMasterDataOptions', JSON.stringify(action.payload))
//     },
//   },
// })

// export const {MasterDataStore} = MasterDataSlice.actions
// export default MasterDataSlice.reducer
